import React from 'react';

import { useHistory } from 'react-router';
import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { IRootState } from 'app/shared/reducers';
import { useSelector } from 'react-redux';
import { getResindSelector } from 'app/modules/cms/service/store/selectors';

import './style.scss';

const contractRescindConfirmation = () => {
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const history = useHistory();
  const resindSelector: any = useSelector(getResindSelector);
  return (
    <>
      <div className="mobile-contract-rescind-confirmation">
        <div className="avatar-style">
          <AvatarWithBadge
            hideButton
            avatar={avatar}
            getPreviousStep={() => {
              history.push({
                pathname: '/contract-engine',
              });
            }}
            title={['  Votre demande de résiliation a bien été prise en compte']}
          />
        </div>
        <div className="confirmation-card d-flex justify-content-center text-center align-items-center">
          <img src={resindSelector?.phone_contact?.url} className="image-stop-style" />
          <div className="label-style">{resindSelector?.confirmation_text}</div>
        </div>
      </div>

      <p
        className="home-link-style"
        onClick={() => {
          history.push({
            pathname: '/contract-engine',
          });
        }}
      >
        <ButtonLounge
          title={resindSelector?.back_button}
          style={'Mobile1 align-self-center mt-1'}
          action={() => {
            history.push({
              pathname: '/contract-engine',
            });
          }}
        />
      </p>
    </>
  );
};

export default contractRescindConfirmation;
